export const SITE_NAME = 'WhoDatNumber';
export const SITE_ORIGIN = 'https://whodatnumber.com';
export const OG_IMAGE_PATH = '/og-image.png';
export const OG_IMAGE_URL = `${SITE_ORIGIN}${OG_IMAGE_PATH}`;
export const DEFAULT_DESCRIPTION =
  'Protect yourself from scam and spam callers. Number lookup, scam checks, and practical safety tips.';
